import {
  Types,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { guidedSetupConfig } from 'client/Discover/components/GuidedSetup/GuidedSetupSettings';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import NavPanelLinkList from 'client/components/NavPanel/NavPanelLinkList';
import Util from 'client/util/Util';

const { PrimaryButtonProps, SecondaryButtonProps } = Types;
const { devicesLink } = NavPanelLinkList;

const {
  description,
  location,
  section,
  text,
  toUrl,
} = eventProperties;

export default {
  EventHelper,
  Util,

  props: {
    selectedInstall: {
      type: Object,
      required: true,
    },

    selectedOs: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    currentStep: 1,
    lastStep: 3,
  }),

  computed: {
    backgroundImage() {
      return this.selectedInstall.images.steps[this.currentStep - 1];
    },

    onLastStep() {
      return this.currentStep === this.lastStep;
    },

    primaryButtonText() {
      return this.onLastStep ? 'Done' : 'Next';
    },

    primaryButtonProps() {
      return PrimaryButtonProps({ text: this.primaryButtonText });
    },

    secondaryButtonText() {
      return this.onLastStep ? 'Go to Devices' : 'Back';
    },

    secondaryButtonProps() {
      return SecondaryButtonProps({ hasNoBackground: true, text: this.secondaryButtonText });
    },

    settings() {
      return guidedSetupConfig[this.selectedOs];
    },
  },

  methods: {
    handleBack() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User went back a step',
        [location]: eventLocations.immersiveOnboarding,
        [section]: `${this.settings.label} - ${this.selectedInstall.header} - step ${this.currentStep}`,
        [text]: this.secondaryButtonText,
      });

      if (this.currentStep === 1) {
        this.$emit('back');
      } else {
        this.currentStep -= 1;
      }
    },

    handleNext() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User proceeded through immersive onboarding',
        [location]: eventLocations.immersiveOnboarding,
        [section]: `${this.settings.label} - ${this.selectedInstall.header} - step ${this.currentStep}`,
        [text]: this.primaryButtonText,
      });

      if (this.currentStep !== this.lastStep) {
        this.currentStep += 1;
      } else {
        this.$emit('close');
      }
    },

    navigateToDevices() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Navigates to the devices page',
        [location]: eventLocations.immersiveOnboarding,
        [section]: `${this.settings.label} - ${this.selectedInstall.header} - step ${this.currentStep}`,
        [text]: this.secondaryButtonText,
        [toUrl]: devicesLink.href,
      });

      this.$options.Util.redirect(devicesLink.href);
    },

    secondaryAction() {
      if (this.onLastStep) {
        this.navigateToDevices();
        this.$emit('close');
      } else {
        this.handleBack();
      }
    },
  },
};
